import { observer } from 'mobx-react-lite';
import { loading } from 'owa-locstrings/lib/strings/loading.locstring.json';
import loc from 'owa-localize';
import { composeStore } from 'owa-mail-compose-store';
import { ComposeCommandingBar } from 'owa-mail-compose-view';
import { DeeplinkMailItemCommandingBar } from 'owa-mail-deeplink-rp-commandbar';
import ReadingPaneContainer from 'owa-mail-reading-pane-container/lib/components/ReadingPaneContainer';
import { ItemReadingPaneViewState } from 'owa-mail-reading-pane-store';
import readingPaneStore from 'owa-mail-reading-pane-store/lib/store/Store';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import {
    getStore as getPopoutChildStore,
    PopoutLoadingView,
    PopoutChildState,
} from 'owa-popout-v2';

import * as React from 'react';

const styles = require('owa-mail-module-view/lib/components/MailModule.scss');

export default observer(function DeepLinkMailView(props: {}) {
    const itemReadingPaneViewState = {
        get(): ItemReadingPaneViewState {
            return readingPaneStore.itemReadingPaneViewState;
        },
    };
    const activeFullCompose =
        composeStore.primaryComposeId && composeStore.viewStates.get(composeStore.primaryComposeId);
    const item = getMailStore().items.get(
        itemReadingPaneViewState.get() && itemReadingPaneViewState.get().itemId
    );
    const isReadonly = itemReadingPaneViewState.get() && itemReadingPaneViewState.get().isReadonly;
    const { state } = getPopoutChildStore();
    return state != PopoutChildState.Ready ? (
        <PopoutLoadingView loadingString={loc(loading)} />
    ) : (
        <div className={styles.rightPane}>
            {!isReadonly && (
                <div className={styles.commandBar}>
                    {activeFullCompose ? (
                        <ComposeCommandingBar composeViewState={activeFullCompose} />
                    ) : item?.NormalizedBody ? (
                        <DeeplinkMailItemCommandingBar
                            itemId={{ ...item.ItemId, mailboxInfo: item.MailboxInfo }}
                        />
                    ) : null}
                </div>
            )}
            <div className={styles.readingPane}>
                <ReadingPaneContainer />
            </div>
        </div>
    );
});
